// src/actions/salesorders.actions.js

import { salesOrderConstants, userConstants } from "../constants";
import { alertActions } from "./alert.actions";
import { entityDataGenerator } from "../helpers";

export const salesOrdersActions = {
  getSalesOrders,
};

function getSalesOrders(rowNums, options = {}, showRecent) {
  return (dispatch) => {
    dispatch(request());
    const getSalesOrdersSummary =
      entityDataGenerator.genSalesOrdersSummary(rowNums, options, showRecent);

    getSalesOrdersSummary
      .then((sOrdersData) => {
        dispatch(success(sOrdersData));
      })
      .catch((err) => {
        dispatch(failure(err.toString()));
        httpErrorHandler(err);
      });
  };

  function request() {
    return { type: salesOrderConstants.SALES_ORDERS_REQUEST };
  }
  function success(orders) {
    return { type: salesOrderConstants.SALES_ORDERS_SUCCESS, orders };
  }
  function failure(error) {
    return { type: salesOrderConstants.SALES_ORDERS_FAILURE, error };
  }
}

function httpErrorHandler(error) {
  return (dispatch) => {
    let httpStatus =
      error.response != undefined ? error.response.status : 404;
    if (httpStatus >= 500 || httpStatus == 404) {
      // Added to handle error(s)
      dispatch(alertActions.error("Network Connection Error."));
    } else if (httpStatus == 401) {
      userActions.msalLogout();
      dispatch({ type: userConstants.LOGOUT });
    } else {
      dispatch(failure(error.toString()));
      dispatch(alertActions.error(error.toString()));
    }
  };
}
